/* version b9cda20 */

(function () {

  window.downpay = window.downpay || {};
  window.downpay.cartRefreshOn = window.downpay.cartRefreshOn || true;
  
  const cartDataEl = document.getElementById('preorder-cart-data');

  const cartFor = document.querySelector('form[action^="/cart"');

  function listenToThemeEditorEvents() {
    document.addEventListener('shopify:section:load', function(event) {
       
    });

    document.addEventListener('shopify:section:unload', function(event) {
      
    });
  }

  // we use this check to see if we're running in the WYSIWYG Shopify theme editor
  if (Shopify.designMode) {
    listenToThemeEditorEvents();
  }

  // we use this check to see if we're running in theme preview mode
  if (Shopify.inspectMode) {
    //console.log(Shopify);
  }

  // utility function that simplifies creation of new html node
  function create({ 
    tag,
    appendTo,
    children = [],
    attributes = {},
    events = {},
  }) {
    const element = document.createElement(tag);

    Object.entries(attributes).forEach(([key, value]) => {
      element[key] = value;
    });

    Object.entries(events).forEach(([key, value]) => {
      element.addEventListener(key, value);
    });

    if (appendTo) {
      appendTo.appendChild(element);
    }

    children.forEach((child) => element.appendChild(child));

    return element;
  }

  function fetchCart(fn) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        fn(cart);
      })
  }

  function findElementByXPath(document, xpath) {
    const result = document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null);
    return result.singleNodeValue;
  }

  function refreshDownpayTotals() {
    fetch(window.location.href)
      .then(response => response.text())
      .then(text => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');

        const dueTodayXPath = findElementByXPath(doc, '//*[@id="downpay-due-today-amount"]');
        const dueLaterXPath = findElementByXPath(doc, '//*[@id="downpay-due-later-amount"]');

        if (dueTodayXPath !== null) {
          const dueTodayVal = dueTodayXPath.innerHTML.trim();
          const dueTodayElement = document.getElementById('downpay-due-today-amount');
          if (dueTodayElement !== null) {
            dueTodayElement.innerHTML = dueTodayVal;
          }
        }

        if (dueLaterXPath !== null) {
          const dueLaterVal = dueLaterXPath.innerHTML.trim();
          const dueLaterElement = document.getElementById('downpay-due-later-amount');
          if (dueLaterElement !== null) {
            dueLaterElement.innerHTML = dueLaterVal; 
          }
        }
      })
  }

  const itemsWithoutPlans = {};
  function applySellingPlansToAddons(cart) {
    const itemsWithPlans = cart.items.filter(item => item.selling_plan_allocation);

    if (itemsWithPlans.length === 0) {
      return;
    };

    const firstPlan = itemsWithPlans[0].selling_plan_allocation.selling_plan.id;

    cart.items.forEach((item, index) => {
      if (item.selling_plan_allocation) {
        return;
      }

      if (!(item.key in itemsWithoutPlans)) {
        itemsWithoutPlans[item.key] = {
          eligible: true,
          payload: {
            line: index + 1,
            quantity: item.quantity,
            selling_plan: `${firstPlan}`
          }
        }
      }
    });

    const cartUrl = `${window.Shopify.routes.root}cart/change.js`;

    for (const [key, item] of Object.entries(itemsWithoutPlans)) {

      if (!item.eligible) {
        continue;
      }

      fetch(cartUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(item.payload)
      }).then(data => {
        if (data.ok) {
          delete itemsWithoutPlans[key];
        } else {
          if (data.status === 422) {
            item.eligible = false;
          }
        }
      });
    };
  }

  function recheckCartTotals(period) {
    let no_change_count = 0;
    let interval = period;
    let item_count, total_price, items_with_options;

    fetchCart((cart) => {
      item_count = cart.item_count;
      total_price = cart.total_price;
      items_with_options = cart.items.filter(item => item.selling_plan_allocation);
    });

    function retryCart() {
      fetchCart((cart) => {
        if (cart.item_count !== item_count || cart.total_price !== total_price || cart.items.filter(item => item.selling_plan_allocation).length !== items_with_options.length) {
          no_change_count = 0;
          interval = period;

          //storefront caching and race conditions can cause storefront rendering to slightly lag behind the actual cart state
          setTimeout(refreshDownpayTotals, 500);

          item_count = cart.item_count;
          total_price = cart.total_price;
          items_with_options = cart.items.filter(item => item.selling_plan_allocation);
        } else {
          no_change_count++;
        }
 
        applySellingPlansToAddons(cart);

        // gradually backs off if there are no cart changes, but resets if any changes are detected
        if (no_change_count % 4 === 0) {
          interval = Math.min(interval * 2, 4000);
        }

        setTimeout(retryCart, interval);
      });
    }
    retryCart();
  }

  // fetch: https://stackoverflow.com/a/64241104/438417
  // load: https://stackoverflow.com/a/63505699/438417
  function listenToQuantityUpdates(ns, fetch) {
    listedToCartCallsMadeWithFetch(ns, fetch);
    listedToCartCallsMadeWithXMLHttpRequest();
  }

  function listedToCartCallsMadeWithFetch(ns, fetch) {
    if (typeof fetch !== 'function') return;

    ns.fetch = function() {
      const response = fetch.apply(this, arguments);

      response.then(res => {
        if ([
            `${window.location.origin}/cart/add.js`,
            `${window.location.origin}/cart/update.js`,
            `${window.location.origin}/cart/change.js`,
            `${window.location.origin}/cart/clear.js`,
            `${window.location.origin}/cart/add`,
            `${window.location.origin}/cart/update`,
            `${window.location.origin}/cart/change`,
            `${window.location.origin}/cart/clear`,
          ].includes(res.url)) {
          res.clone().json().then(_data => refreshDownpayTotals());
        }
      });

      return response;
    }
  }

  function listedToCartCallsMadeWithXMLHttpRequest() {
    const open = window.XMLHttpRequest.prototype.open;

    function openReplacement() {
      this.addEventListener("load", function () {
        if (
          [
            "/cart/add.js",
            "/cart/update.js",
            "/cart/change.js",
            "/cart/clear.js",
            "/cart/add",
            "/cart/update",
            "/cart/change",
            "/cart/clear",
          ].includes(this._url)
        ) {
          refreshDownpayTotals();
        }
      });
      return open.apply(this, arguments);
    }

    window.XMLHttpRequest.prototype.open = openReplacement;
  }

  listenToQuantityUpdates(window, window.fetch);
  if (window.hypehound.downpay.cartRefreshOn) {
    recheckCartTotals(500);
  }
})();